// const convertToTaxIncluded = () => {
//   document.querySelectorAll('.mxpr-grid-price-column span').forEach((el) => {
//     if (el.dataset.taxConverted) return;
//     const price = parseInt(el.textContent.replace(/[¥,]/g, ''), 10);
//     if (isNaN(price)) return;
//     const taxIncluded = Math.floor(price * 1.1);
//     el.textContent = '¥' + taxIncluded.toLocaleString('ja-JP');
//     el.dataset.taxConverted = 'true';
//   });
// };

const observer = new MutationObserver(() => {
  convertToTaxIncluded();
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});